import { fetchApi } from '../../api-client';

export const HOUSE_POINTS_PATH = '/house-point-adjustments';

export interface HousePointAdjustment {
  id: string;
  houseId: string;
  houseName: string | null;
  houseColor: string | null;
  amount: number;
  categoryId: string;
  categoryName: string | null;
  categoryColor: string | null;
  adminUserId: string;
  adminEmail: string | null;
  schoolYearId: string;
  schoolYearCode: string | null;
  schoolYearName: string | null;
  awardedAt: string;
  note: string | null;
  createdAt: string;
}

export interface HousePointAdjustmentListResponse {
  data: HousePointAdjustment[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
}

export interface HousePointAdjustmentsFilters {
  page?: number;
  limit?: number;
  houseId?: string;
  categoryId?: string;
  schoolYearId?: string;
  from?: string;
  to?: string;
  sortBy?: 'date' | 'house' | 'amount' | 'category';
  sortDir?: 'asc' | 'desc';
}

export interface CreateHousePointAdjustmentInput {
  houseId: string;
  amount: number;
  categoryId: string;
  awardedAt?: string;
  note?: string;
}

export type UpdateHousePointAdjustmentInput = Partial<Omit<CreateHousePointAdjustmentInput, 'houseId'>>;

function toQuery(filters: HousePointAdjustmentsFilters): string {
  const params = new URLSearchParams();
  Object.entries(filters).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== '') params.set(k, String(v));
  });
  const q = params.toString();
  return q ? `?${q}` : '';
}

export const housePointsApi = {
  list: (filters: HousePointAdjustmentsFilters = {}) =>
    fetchApi<HousePointAdjustmentListResponse>(`${HOUSE_POINTS_PATH}${toQuery(filters)}`),
  create: (data: CreateHousePointAdjustmentInput) =>
    fetchApi<HousePointAdjustment>(HOUSE_POINTS_PATH, { method: 'POST', body: JSON.stringify(data) }),
  update: (id: string, data: UpdateHousePointAdjustmentInput) =>
    fetchApi<HousePointAdjustment>(`${HOUSE_POINTS_PATH}/${id}`, { method: 'PATCH', body: JSON.stringify(data) }),
  delete: (id: string) => fetchApi<{ success: boolean }>(`${HOUSE_POINTS_PATH}/${id}`, { method: 'DELETE' }),
};
